
<template>
  <b-container fluid>
    <!-- Search Form -->
    <!-- <iq-card>
      <template v-slot:headerTitle>
          <h4 class="card-title">{{ $t('social_service.social_service_delivery') }}</h4>
      </template>
      <template v-slot:body>
          <b-row>
            <b-col xl="6" lg="6" md="6" sm="12" xs="12">
              <b-form-group
              class="row"
              label-cols-sm="5"
              :label="$t('social_service.social_service_cat')"
              label-for="registration_id"
              >
                <b-form-select
                  plain
                  v-model="search.registration_id"
                  :options="applicationNameList"
                  id="application_id"
                  >
                  <template v-slot:first>
                  <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12" xs="12">
              <b-form-group
              class="row"
              label-cols-sm="5"
              :label="$t('social_service.date')"
              label-for="registration_id"
              >
              <flat-pickr class="form-control"
                v-model="search.sequence_date"
                :placeholder="$t('globalTrans.select_date')"
              ></flat-pickr>
              </b-form-group>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12" xs="12">
                <b-form-group
                class="row"
                label-cols-sm="5"
                :label="$t('globalTrans.division')"
                label-for="registration_id"
                >
                  <b-form-select
                    plain
                    v-model="search.institute_id"
                    :options="applicationNameList"
                    id="application_id"
                    >
                    <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12" xs="12">
                <b-form-group
                class="row"
                label-cols-sm="5"
                :label="$t('globalTrans.district')"
                label-for="registration_id"
                >
                  <b-form-select
                    plain
                    v-model="search.institute_id"
                    :options="applicationNameList"
                    id="application_id"
                    >
                    <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12" xs="12">
                <b-form-group
                class="row"
                label-cols-sm="5"
                :label="$t('globalTrans.upazila')"
                label-for="registration_id"
                >
                  <b-form-select
                    plain
                    v-model="search.institute_id"
                    :options="applicationNameList"
                    id="application_id"
                    >
                    <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12" xs="12">
              <b-form-group
              class="row"
              label-cols-sm="5"
              :label="$t('social_service.patient')"
              label-for="registration_id"
              >
              <b-form-input
              v-model="search.patient"
              >
              </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
            </b-col>
          </b-row>
      </template>
    </iq-card> -->
    <!-- /Search Form -->
    <b-row>
      <b-col md="12">
        <iq-card>
          <!-- Add New -->
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('social_service.social_service_delivery')}}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary">
              <router-link :to="{ path: '/hospital-disability-service/social-service/social-service-delivery-add'}"><i class="fas fa-plus"></i> {{ $t('globalTrans.add_new') }}
              </router-link>
            </b-button>
          </template>
          <!-- /Add New -->
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">

                  <!-- Table -->
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null">
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>

                    <!-- Name -->
                    <template v-slot:cell(class_name)="data">
                      <span class="capitalize">{{ data.item.class_name }}</span>
                    </template>

                    <!-- Active/Inactive -->
                 <!--    <template v-slot:cell(status)="data">
                        <span class="badge badge-danger" v-if="data.item.status == 2">{{$t('globalTrans.inactive')}}</span>
                        <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                    </template> -->

                    <template v-slot:cell(action)="data">

                      <!-- Modal 1 -->
                      <!-- <b-button variant=" iq-bg-success mr-1 mb-1" size="sm">
                          <router-link :to="{ path: '/hospital-disability-service/social-service/social-service-delivery-add', query: { id: data.item.id }}" class="iq-bg-success mr-1 mb-1" size="sm"><i class="ri-ball-pen-fill m-0"></i>
                          </router-link>
                      </b-button>
                      <b-button variant=" iq-bg-success mr-1 mb-1" size="sm">
                          <router-link :to="{ path: '/hospital-disability-service/social-service/social-service-delivery-details', query: { id: data.item.id }}" class="iq-bg-success mr-1 mb-1" size="sm"><i class="ri-eye-line m-0"></i>
                          </router-link>
                      </b-button> -->
                          <router-link :to="{ path: '/hospital-disability-service/social-service/social-service-delivery-add', query: { id: data.item.id }}" class="btn_table_action btn_blue"><i class="ri-ball-pen-fill"></i>
                          </router-link>
                          <router-link :to="{ path: '/hospital-disability-service/social-service/social-service-delivery-details', query: { id: data.item.id }}" class="btn_table_action btn_green"><i class="fas fa-eye"></i>
                          </router-link>
                    </template>
                  </b-table>

                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>

     <b-modal id="modal-4" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Form :id="editItemId" :key="editItemId"/>
    </b-modal>
     <b-modal id="modal-5" size="xl" :title="$t('social_service.social_service_delivery')"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :id="editItemId" :key="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import Details from './Details'
import Form from './Form'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { socialServiceDeliveryList, seizerStatus, assignUserHospitalApi } from '../../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Form,
    Details
  },
  data () {
    return {
      search: {
        registration_id: 0,
        institute_id: 0
      },
      hospitalIds: [],
      userId: 0,
      hospitalLoad: false,
      rows: []
    }
  },
  computed: {
    applicationNameList: function () {
        return this.$store.state.ChildService.commonObj.applicationNameList
    },
    socialServiceDeliveryList: function () {
        return this.$store.state.ChildService.commonObj.socialServiceDeliveryList.filter(item => item.status === 1)
    },
    formTitle () {
        return (this.editItemId === 0) ? this.$t('social_service.social_service_delivery') + ' ' + this.$t('globalTrans.entry') : this.$t('social_service.social_service_delivery') + ' ' + this.$t('globalTrans.modify')
    },
    // b-table :items="listData" :fields="columns"
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('social_service.patient'), class: 'text-center' },
          { label: this.$t('social_service.address'), class: 'text-center' },
          { label: this.$t('social_service.social_service_cat'), class: 'text-center' },
          { label: this.$t('social_service.comment'), class: 'text-center' },
          // { label: this.$t('social_service.training_type'), class: 'text-center' },
          // { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'patient_name_bn' },
          { key: 'address_bn' },
          { key: 'service_category' },
          { key: 'comment' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'patient_name' },
          { key: 'address' },
          { key: 'service_category' },
          { key: 'comment' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  created () {
    this.hospitalLoad = true
        var officeId = this.$store.state.Auth.authUser.office_id
        if (officeId > 1) {
            this.userId = this.$store.state.Auth.authUser.user_id
            if (this.userId > 1) {
                this.getUserWiseHospital(this.userId)
            }
        } else {
            this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                this.hospitalIds.push(obj.value)
            })
            this.loadData()
            // this.hospitalList = this.getHospitalList()
        }
  },
  methods: {
    async getUserWiseHospital (userId) {
        const params = Object.assign({ user_id: userId })
        const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
        if (result.success) {
                this.hospitalIds = result.data
        } else {
              this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                  this.hospitalIds.push(obj.value)
              })
        }
        this.loadData()
        // this.hospitalList = this.getHospitalList()
    },
    searchData () {
      this.loadData()
    },
    remove (item) {
      this.changeStatus(hospitalServiceBaseUrl, seizerStatus, item)
    },
    loadData () {
      var seizerSearch = ''
      if (this.search.seizer_id) {
          seizerSearch = this.search.seizer_id.value
      }
      const params = Object.assign({}, this.search, { seizer_id: seizerSearch, page: this.pagination.currentPage, per_page: this.pagination.perPage, user_id: this.userId })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(hospitalServiceBaseUrl, socialServiceDeliveryList, params).then(response => {
        if (response.success) {
          this.$store.dispatch('setList', this.getRelationalData(response.data.data))
          this.paginationData(response.data)
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
        const listData = data.map(item => {
          const serviceCategoryArray = JSON.parse('[' + item.service_category + ']')
          const serviceCategory = serviceCategoryArray.map(item => {
            const objectData = this.$store.state.HospitalDisabilityService.commonObj.socialServiceCategoryList.find(item1 => item1.value === item)
            if (objectData) {
              if (this.$i18n.locale === 'bn') {
                  return objectData.text_bn
              } else {
                 return objectData.text_en
              }
            } else {
              return ''
            }
          })
          const evaluationData = {
              service_category: serviceCategory !== undefined ? serviceCategory.toString() : ''
          }

            return Object.assign({}, item, evaluationData)
        })
        return listData
    }

    /**
     * Component uses  - Mixin: ModalBaseMasterList
     * resetId(), edit(), paginationData(), changeStatus() & More
     */
  }
}
</script>
